module.exports = __webpack_public_path__ + "static/media/whatsapp-white.1509c947.svg";